import {
  TOrderCreate,
} from '@/types/order.ts';

const strategy: Record<TOrderCreate['target']['strategy'], string> = {
  weight: 'Gewicht',
  quantity: 'Stück',
};

export default strategy;
